import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import ContactForm from './ContactForm';
import './About.css';

class About extends Component {
	render() {
		return (
		<div className='About-content'>
			<Row className='justify-content-center px-3 pb-3'>
				<Col sm={12}>
					<h2 className='text-center'>About the Platform</h2>
				</Col>
				<Col sm={10} md={8} lg={6}>
					<p>The Toronto 2030 Platform was developed by the <a href="https://www.canurb.org">Canadian Urban Institute (CUI)</a> to track building performance and progress towards greenhouse gas reduction targets in the Toronto 2030 District. It displays energy use, water consumption and transportation emissions data for the District by building type and block.</p>
					<p>CUI collaborated Ryerson University, University of Toronto, Toronto Hydro and an <a href="#advisory-panel">Advisory Panel</a> of building industry experts. The Platform is designed to be replicable in communities of all sizes.</p>
					<h5>What does it do?</h5>
					<p>The Toronto 2030 Platform is designed to help users:</p>
						 <ul>
   					  <li>Understand how downtown Toronto is progressing towards reaching emissions reductions targets;</li>
						  <li>Benchmark their buildings;</li>
							<li>Connect to conservation programs; and</li>
							<li>Commit to the District 2030 goals.</li>
						</ul>
					</Col>
				<Col sm={12}>
					<h2 className='text-center'>About the Toronto 2030 District</h2>
				</Col>
				<Col sm={10} md={8} lg={6}>					
					<p>The Toronto 2030 District is a private-public initiative committed to achieving a low-carbon future. We are a broad stakeholder network comprised of property owners and managers, tenants, utilities, government, service providers and civil society within Toronto’s downtown core. Our focus is on reducing building-related energy use, water consumption, and transportation emissions. </p>
					<p><a href="https://www.2030districts.org/toronto/about">Learn more about the Toronto 2030 District</a></p>
				</Col>
			</Row>
			<Row className='justify-content-center px-3 pb-5'>
				<Col sm={10} md={8} lg={6} className='justify-content-center text-center px-3 sponsors'>
					<h5>Platinum Sponsors:</h5>
						<div><img className='img-fluid mb-4' src='images/ctl-group-logo.jpg' alt='CTL Group' /></div>
						<div><img className='img-fluid mb-0 mx-4' src='images/oaa-logo.jpg' alt='Ontario Association of Architects' /><br /><small>*Founding Sponsor</small></div>
						<div><img className='img-fluid mb-0 mx-4' src='images/sbc-logo.jpg' alt='Sustainable Buildings Canada' /><br /><small>*Founding Sponsor</small></div>
					<h5>Contributing Sponsor:</h5>
					<img className='img-fluid mb-4' src='images/enwave-logo.jpg' alt='Enwave Energy Corporation' />
				</Col>			
			</Row>					
			<Row className='justify-content-center px-3 py-5 bg-light'>
				<Col sm={10} md={8} lg={6}>
					<h2 className='text-center'>Sign-up for our mailing list</h2>
					<ContactForm />
					<p className='mt-3 large'>Want to chat with us about the Toronto 2030 District?<br /><br />Contact us:<br />
					<a href='mailto:toronto@2030districts.org' ><FontAwesomeIcon icon={faEnvelope} /> toronto@2030districts.org</a><br />
					<FontAwesomeIcon icon={faPhone} /> 416-365-0816 ext. 290</p>
				</Col>
			</Row>	
			<Row className='justify-content-center text-center px-3 py-5'>
				<Col sm={9} className='mb-5 text-center'>
					<img className='img-fluid' src='images/toronto-2030-platform-graphic.png' alt='Toronto skyline'/>
				</Col>
				<Row className='justify-content-center text-center px-3 py-5'>
				<Col sm={10} md={8} lg={6}>
					<h2>Acknowledgements</h2>
					<h5>Platform Partners:</h5>
					<img className='img-fluid mb-5' src='images/toronto-2030-platform-partners.png' alt='Toronto 2030 Platform Partners' />
					<a name='advisory-panel'></a><h5>Platform Advisory Panel:</h5>
					<img className='img-fluid mb-4' src='images/toronto-2030-platform-advisory-20190220.jpg' alt='Toronto 2030 Platform Advisory Panel' />
				</Col>	
				</Row>
				<Col sm={12} className='social text-center'>
					<a href="https://twitter.com/TO_2030District"><FontAwesomeIcon icon={faTwitter} size='lg' /></a>{'    '}
					<a href="https://www.linkedin.com/groups/8135789"><FontAwesomeIcon icon={faLinkedinIn} size='lg' /></a>{'    '}
					<a href="https://www.facebook.com/Toronto2030District/"><FontAwesomeIcon icon={faFacebookF} size='lg' /></a>
				</Col>
			</Row>
		</div>
		)
	}
}

export default About;


// WEBPACK FOOTER //
// ./src/About.js